import React, { useEffect, useState } from "react";
import DTOAwardsARModal from "./DTOAwardsARModal";
import AwardsARModalPresenter from "./AwardsARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  awardHistory?: any;
  awardData?: any;
}

const AwardsARModalController = ({
  isModalOpen,
  closeModal,
  awardData,
  awardHistory,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const { t } = useTranslation();
  const [all_actions, setAll_actions] = useState([]);
  const getActions = (act: any) => {
    setAll_actions(act);
  };

  const performActiononAward = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOAwardsARModal setAllActions={getActions} />

      <AwardsARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        awardHistory={awardHistory}
        awardData={awardData}
        all_actions={all_actions}
        userId={selector.user_id}
        handleSubmitAR_Request={performActiononAward}
      />
    </div>
  );
};

export default AwardsARModalController;
